import { render, staticRenderFns } from "./EntityDetail.vue?vue&type=template&id=0a7cbaaa&scoped=true&"
import script from "./EntityDetail.vue?vue&type=script&lang=js&"
export * from "./EntityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7cbaaa",
  null
  
)

export default component.exports